import { empApi } from "./client";

// Danh sách dự án -> { items, pagination }
export const getProjectListApi = (params) => empApi.get("/project/app", params);

// Chi tiết dự án
export const getProjectByIdApi = (id) => empApi.get(`/project/app/${id}`);

// Danh sách tỉnh/thành phố -> { items }
export const getCityListApi = (params = { page: 1, limit: 9999 }) =>
  empApi.get("/city", params);
